import React from "react";

import { Helmet } from "react-helmet";
import Breadcrumb from "../../Component/Breadcrumb";
import { useAuth } from "../../Store/AuthContext";

export default function LegalDocumentationSupport() {
  const { webSetting, Pagemetatags } = useAuth();
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.LegalSupport_title}</title>
        <meta
          name="description"
          content={Pagemetatags.LegalSupport_description}
        />
        <meta name="keywords" content={Pagemetatags.LegalSupport_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb pagename={"Legal Documentation Support"} mainpage="" />

      <section className="service-details-section section-padding pt-3">
        <div className="container">
          <div className="service-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div className="gt-details-content">
                  <div
                    className="gt-list-content mb-0"
                    dangerouslySetInnerHTML={{
                      __html: webSetting.LegalSupport_desc,
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
